module.exports = __webpack_public_path__ + "img/banner-shaicha.f2d99c6c.png";